import ModifyQuote from '../modifyQuote';
import ProceedWithOrder from '../proceedWithOrder';
import DownloadQuotePdf from '../downloadQuotePdf';
import ViewOrder from '../viewOrder';
import QuoteReference from '../quoteReference';
import AssignTo from '../assignTo';
import SendToSrt from '../sendToSrt';
import RequestContractResend from '../requestContractResend';
import RequestOrderReturn from '../requestOrderReturn';
import CancelOrder from '../cancelOrder';

export const actionsSalesRepWithSrt = {
  incomplete: [ModifyQuote, CancelOrder],
  pending: [CancelOrder],
  approved: [SendToSrt, DownloadQuotePdf],
  pendingValidation: [ViewOrder],
  waitingOnCredit: [ViewOrder],
  waitingOnSales: [ViewOrder],
  contractSent: [ViewOrder],
  contractSigned: [ViewOrder],
  contractExpired: [ViewOrder],
  validated: [ViewOrder],
  withConcierge: [ViewOrder],
  orderCanceled: [ViewOrder],
  implementationInProgress: [ViewOrder],
  waitingOnCompletionCall: [ViewOrder],
  orderInstalled: [ViewOrder]
};

export const actionsSrtGroup = {
  incomplete: [ModifyQuote, CancelOrder],
  pending: [CancelOrder],
  approved: [
    ProceedWithOrder,
    ModifyQuote,
    CancelOrder,
    AssignTo,
    QuoteReference,
    DownloadQuotePdf
  ],
  pendingValidation: [ViewOrder, RequestOrderReturn, CancelOrder],
  waitingOnCredit: [ViewOrder, RequestOrderReturn, CancelOrder],
  waitingOnSales: [ModifyQuote, ViewOrder, CancelOrder, DownloadQuotePdf],
  contractSent: [
    ViewOrder,
    RequestContractResend,
    RequestOrderReturn,
    CancelOrder
  ],
  contractSigned: [ViewOrder],
  contractExpired: [ViewOrder, CancelOrder],
  validated: [ViewOrder],
  withConcierge: [ViewOrder],
  orderCanceled: [ViewOrder],
  implementationInProgress: [ViewOrder],
  waitingOnCompletionCall: [ViewOrder],
  orderInstalled: [ViewOrder]
};

export const actionsRest = {
  incomplete: [ModifyQuote, CancelOrder],
  pending: [CancelOrder],
  approved: [ProceedWithOrder, ModifyQuote, CancelOrder, DownloadQuotePdf],
  pendingValidation: [ViewOrder, RequestOrderReturn, CancelOrder],
  waitingOnCredit: [ViewOrder, RequestOrderReturn, CancelOrder],
  waitingOnSales: [ModifyQuote, ViewOrder, CancelOrder, DownloadQuotePdf],
  contractSent: [
    ViewOrder,
    RequestContractResend,
    RequestOrderReturn,
    CancelOrder
  ],
  contractSigned: [ViewOrder],
  contractExpired: [ViewOrder, CancelOrder],
  validated: [ViewOrder],
  withConcierge: [ViewOrder],
  orderCanceled: [ViewOrder],
  implementationInProgress: [ViewOrder],
  waitingOnCompletionCall: [ViewOrder],
  orderInstalled: [ViewOrder]
};
